export const unit = {
    ZERO: 0,
    BASE: 3,
    DOUBLE: 6
}